import { useCallback, useRef } from 'react';
import { DataGridHandle } from 'react-data-grid';

export const useRefWithCallback = <T extends HTMLElement | DataGridHandle>(
    setCallback: (node: T | null) => void,
    cleanupCallback?: (node: T | null) => void
) => {
    const ref = useRef<T | null>();

    const refCallback = useCallback((node: T | null) => {
        if (ref.current) {
            cleanupCallback && cleanupCallback(ref.current);
        }

        if (node) {
            setCallback(node);
        }

        ref.current = node;
    }, []);

    return { refCallback, ref };
};
